/* 🤖 this file was generated by svg-to-ts */
export const mgcIconLeftCuteRe: {
  name: 'left-cute-re';
  data: string;
} = {
  name: 'left-cute-re',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M14.26 5.435c-.247.112-1.063.652-1.64 1.085a17.552 17.552 0 0 0-3.7 3.8c-.59.823-.719 1.125-.719 1.68s.129.857.719 1.68a17.374 17.374 0 0 0 4.642 4.461c.665.438.795.497 1.1.498.748.003 1.211-.766.868-1.442-.094-.186-.161-.251-.47-.455a60 60 0 0 1-.82-.558c-1.466-1.015-2.949-2.518-3.899-3.954l-.152-.23.152-.23c.95-1.436 2.433-2.939 3.899-3.954.253-.176.622-.426.82-.558.309-.204.376-.269.47-.455.343-.676-.12-1.445-.868-1.442-.147 0-.305.029-.402.074"/></svg>`
};
